import fromAnyToString from 'utils/converters/fromAnyToString';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const DEFAULT_MAX = 6;

const truncateString = (options) => {
  //
  const value = fromAnyToString(options?.value);
  const suffix = fromAnyToString(options?.suffix);
  const max = isPositiveInteger(options?.max) ? options?.max : DEFAULT_MAX;

  if (value.length <= max) {
    return value;
  }

  const truncateLength = max - suffix.length;

  return `${value.substring(0, truncateLength)}${suffix}`;
};

export default truncateString;
